import api from "./axios";

export const AI_REPORT_SETTINGS_CHANGED_EVENT = "ai-report-settings-changed";

export type AiReportSettings = {
  group_id: number;
  days: number[];
  ai_reports_enabled: boolean;
};

export type AiReportStatus = {
  group_id: number;
  is_running: boolean;
  has_latest: boolean;
  updated_at: string | null;
  size_bytes: number | null;
};

export type AiReportSettingsPayload = { group_id: string; days: number[] };

export async function getAiReportSettings(groupId: number, signal?: AbortSignal) {
  const { data } = await api.get<AiReportSettings>("/api/v1/ai-report-settings", {
    params: { group_id: groupId }, signal,
  });
  return data;
}

export async function saveAiReportSettings(payload: AiReportSettingsPayload, signal?: AbortSignal) {
  const { data } = await api.post("/api/v1/ai-report-settings", payload, { signal });
  if (data?.status === "error") {
    throw new Error(getAiReportErrorMessage({ response: { data } }, "Не удалось сохранить дни генерации"));
  }
  // Только backend подтверждает локальную доступность после сохранения в SuperDB.
  const settings = await getAiReportSettings(Number(payload.group_id), signal);
  if (!signal?.aborted) window.dispatchEvent(new Event(AI_REPORT_SETTINGS_CHANGED_EVENT));
  return settings;
}

export async function getAiReportStatus(groupId: number, signal?: AbortSignal) {
  const { data } = await api.get<AiReportStatus>(`/api/v1/ai-reports/${groupId}/status`, { signal });
  return data;
}

export async function getLatestAiReport(groupId: number, signal?: AbortSignal) {
  const { data } = await api.get<string>(`/api/v1/ai-reports/${groupId}/latest`, {
    responseType: "text", signal,
  });
  return data;
}

export async function startAiReport(groupId: number, signal?: AbortSignal) {
  await api.post(`/api/v1/ai-reports/${groupId}`, undefined, { params: { days: 28 }, signal });
}

export function isAiReportsDisabledError(error: any) {
  return error?.response?.status === 403 && error?.response?.data?.detail?.code === "ai_reports_disabled";
}

export function getAiReportErrorMessage(error: any, fallback = "Не удалось загрузить ИИ-отчёт. Попробуйте открыть его позже.") {
  const data = error?.response?.data;
  const message = data?.detail?.message ?? data?.detail ?? data?.error ?? data?.message;
  if (typeof message === "string" && message.trim()) return message;
  if (!error?.response && !error?.isAxiosError && error instanceof Error) return error.message;
  return fallback;
}
